import { Component } from '@angular/core';

@Component({
    selector: 'anp-mail-info',
    templateUrl: './mail-info.component.html',
    standalone: false
})
export class MailInfoComponent {}
